import React from "react";
import { genURL } from './../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Checkmaingroup from './../CustomFunction/Product/Checkmaingroup'
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
import axios from "axios";
require('./../_css/PopUpOther.css');
//จำนวนแถว
/* const rowTable = 15; */

export default class PopUpOther extends React.Component {
    state = {
        /* type: this.props.type, */
        col: [],
        rows: [],
        valueRetuen: "",
        Htext: "",
        SHtype: 3,
        casschkbox: "far fa-square",
        casschkboxs: false,
        ckbox_length: 0,
        docno: "",
        rsData: []
    }
    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date1 = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date1 + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    Get_Data = (event, data) => {
        // console.log(event, data);
        var dataArray = [];
        var code = ""
        if (event === "true") {
            code = "&docno=" + this.state.docno
        } else {
            code = "&docno=" + this.refs.Code.value
        }
        var Url = "CSV_SALEREFDOCNO3/getsubdocno?arcode=" + this.props.ARCODE + code;
        axios.get(genURL(Url)).then(res => {
            //   console.log("data", res); 
            var j = 0;
            if (res.data.length > 0) {
                let maingroup
                for (let i = 0; i < res.data.length; i++) {
                    Checkmaingroup(res.data[i].PRODUCTCODE).then(data => { maingroup = data })
                    dataArray[j] = {
                        number: i + 1,
                        Col1: res.data[i].DOCNO,
                        Col2: res.data[i].PRODUCTCODE,
                        Col3: res.data[i].PRODUCTNAME,
                        Col4: res.data[i].UNITNAME,
                        Col5: res.data[i].ISSQTY,
                        Col6: res.data[i].ISSREM,
                        Col7: res.data[i].SHIPQTY,
                        Col8: res.data[i].UNITPRICE,
                        Col9: res.data[i].DISCWORD,
                        Col10: res.data[i].SALENAME,
                        Col11: res.data[i].SALEREMARK,
                        Col12: res.data[i].SHIPREMARK,
                        Col13: res.data[i].WAREHOUSE === null ? "" : typeof res.data[i].WAREHOUSE !== undefined ? res.data[i].WAREHOUSE : "",
                        Col14: res.data[i].LOCATION,
                        _unitCode: res.data[i].UNITCODE,
                        _refLineID: res.data[i].REFLINEID,
                        SB: "0",
                        docgroup: maingroup

                    }
                    j++;
                }

                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            } else {
                dataArray = [];
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }
        });
        this.setState({ col: dataArray, Htext: "เลือกรายการย่อย" });
        this.setState({ rows: this.state.rows });
    }
    GetSearchTimeout = () => {
        this.setState({ rows: this.state.col });
    }
    componentDidMount() {
        /* console.log(this.props.type,"test"); */
        /* this.setRow(rowTable); */
        this.loadData()
    }

    loadData = async () => {
        await this.getData()
    }
    getData = async () => {
        this.setState({ openBackdrop: true })
        var dataArray = [];
        this.setState({ sh_Deposit: true });
        /* console.log(this.props.P_DOCNO, "start"); */
        this.setState({ docno: this.props.P_DOCNO })
        // console.log(this.props.ARCODE, this.props.P_DOCNO);
        var Url = "CSV_SALEREFDOCNO3/getsubdocno?arcode=" + this.props.ARCODE + this.props.P_DOCNO;
        axios.get(genURL(Url)).then(res => {
            console.log("CSV_SALEREFDOCNO3sub", res);
            var j = 0;
            if (res.data.length > 0) {
                let maingroup
                for (let i = 0; i < res.data.length; i++) {
                    // console.log("ssssscccccc", res.data);
                    dataArray[j] = {
                        number: i + 1,
                        Col1: res.data[i].DOCNO,
                        Col2: res.data[i].PRODUCTCODE,
                        Col3: res.data[i].PRODUCTNAME,
                        Col4: res.data[i].UNITNAME,
                        Col5: res.data[i].ISSQTY,
                        Col6: res.data[i].ISSREM,
                        Col7: res.data[i].SHIPQTY,
                        Col8: res.data[i].UNITPRICE,
                        Col9: res.data[i].DISCWORD,
                        Col10: res.data[i].SALENAME,
                        Col11: res.data[i].SALEREMARK,
                        Col12: res.data[i].SHIPREMARK,
                        Col13: res.data[i].WAREHOUSE === null ? "" : typeof res.data[i].WAREHOUSE !== undefined ? res.data[i].WAREHOUSE : "",
                        Col14: res.data[i].LOCATION,
                        _unitCode: res.data[i].UNITCODE,
                        _refLineID: res.data[i].REFLINEID,
                        maingroup: "",
                        STOCKTYPE: res.data[i].STOCKTYPE,
                        ITEMTAXTYPE: res.data[i].ITEMTAXTYPE,
                        productset: res.data[i].PRODUCTSET,
                        SB: "0"
                    }
                    j++;
                    // console.log("sssssGetCorServicei", i);
                }
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            } else {
                dataArray = [];
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }

        }).catch(_ => {
            this.setState({ openBackdrop: false })
        }).finally(_ => {
            this.setMaingrouop()
        });
        this.setState({ col: dataArray, Htext: "เลือกรายการย่อย" });
    }

    setMaingrouop = async () => {
        let colItem = this.state.col
        let datalist = []
        // sleep(1000).then(() => {
        for (let index = 0; index < colItem.length; index++) {
            // const element = array[index];
            // console.log("sssss" + index, colItem[index].Col2);
            await Checkmaingroup(colItem[index].Col2).then(data => {
                // console.log("sssssdata", data)
                datalist[index] = {
                    number: colItem[index].number,
                    Col1: colItem[index].Col1,
                    Col2: colItem[index].Col2,
                    Col3: colItem[index].Col3,
                    Col4: colItem[index].Col4,
                    Col5: colItem[index].Col5,
                    Col6: colItem[index].Col6,
                    Col7: colItem[index].Col7,
                    Col8: colItem[index].Col8,
                    Col9: colItem[index].Col9,
                    Col10: colItem[index].Col10,
                    Col11: colItem[index].Col11,
                    Col12: colItem[index].Col12,
                    Col13: colItem[index].Col13,
                    Col14: colItem[index].Col14,
                    _unitCode: colItem[index]._unitCode,
                    _refLineID: colItem[index]._refLineID,
                    maingroup: data,
                    STOCKTYPE: colItem[index].STOCKTYPE,
                    ITEMTAXTYPE: colItem[index].ITEMTAXTYPE,
                    productset: colItem[index].productset,
                    SB: colItem[index].SB
                }
            })

        }
        this.setState({ col: datalist });
        this.GetSearchTimeout();
        this.setState({ openBackdrop: false })
        // })
    }
    cellcheckbok = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.rows[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0": btnShow = <span>
                <i class="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")}> </i>
            </span>;
                break;
            case "1": btnShow = <span>
                <i class="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i class="">  </i></span>;
        }
        return (<div>{btnShow}</div>)
    }
    Update_Status = (Row, Status) => {
        if (Status === "ALL") {
            if (this.state.casschkboxs === false) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                var dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                    dataArray[i].SB = "1";
                }
                this.setState({ row: dataArray });
            } else {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                var dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                    dataArray[i].SB = "0";
                }
                this.setState({ row: dataArray });
            }
        } else {
            if (Status === "0") {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: false });
            }
            var dataArray = this.state.rows;
            dataArray[Row].SB = Status;
            this.setState({ rows: dataArray });
            var sb_length = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                if (this.state.rows[i].SB === "1") { sb_length = sb_length + 1; }
            }
            if (sb_length === this.state.rows.length) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: true });
            }
        }
    }
    onSelectRow = (data, col, id, row) => {
        this.setState({ valueRetuen: data.code });
        console.log("xxxxxxxxxxxxxxxxxx", col);
        if (col > 1 && data.Col1 !== undefined) {
            //เท่ากับเลือกรายการเมื่อคลิกแถว
            var dataArray = this.state.rows;
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            this.setState({ Col1: data.Col1 });
            console.log(data.Col1);
            //------------------------
            var reData = [];
            let j = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                console.log("xxxxxxxxxxxxxxxxxxxx", this.state.rows[i].SB);
                if (this.state.rows[i].SB === "1") {
                    reData[j] = {
                        Col1: this.state.rows[i].Col1,
                        Col2: this.state.rows[i].Col2,
                        Col3: this.state.rows[i].Col3,
                        Col4: this.state.rows[i].Col4,
                        Col5: this.state.rows[i].Col5,
                        Col6: this.state.rows[i].Col6,
                        Col7: this.state.rows[i].Col7,
                        Col8: this.state.rows[i].Col8,
                        Col9: this.state.rows[i].Col9,
                        Col10: this.state.rows[i].Col10,
                        Col11: this.state.rows[i].Col11,
                        Col12: this.state.rows[i].Col12,
                        Col13: this.state.rows[i].Col13,
                        Col14: this.state.rows[i].Col14,
                        _unitCode: this.state.rows[i]._unitCode,
                        _refLineID: this.state.rows[i]._refLineID,
                        maingroup: this.state.rows[i].maingroup,
                        STOCKTYPE: this.state.rows[i].STOCKTYPE,
                        ITEMTAXTYPE: this.state.rows[i].ITEMTAXTYPE,
                        productset: this.state.rows[i].productset
                    }
                    j++
                }
            }
            console.log("reData", reData)
            if (reData.length !== 0) {
                this.props.Get_PopUpSelSaleRef3Sub(reData);
                //  this.setState({ rsData: reData })
            }
        }
    }
    onSubmit = (e) => {
        var sb_length = 0;
        var reData = [];
        for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
            console.log(this.state.rows[i].SB);
            if (this.state.rows[i].SB === "1") {
                sb_length = sb_length + 1;
                reData[i] = {
                    Col1: this.state.rows[i].Col1,
                    Col2: this.state.rows[i].Col2,
                    Col3: this.state.rows[i].Col3,
                    Col4: this.state.rows[i].Col4,
                    Col5: this.state.rows[i].Col5,
                    Col6: this.state.rows[i].Col6,
                    Col7: this.state.rows[i].Col7,
                    Col8: this.state.rows[i].Col8,
                    Col9: this.state.rows[i].Col9,
                    Col10: this.state.rows[i].Col10,
                    Col11: this.state.rows[i].Col11,
                    Col12: this.state.rows[i].Col12,
                    Col13: this.state.rows[i].Col13,
                    Col14: this.state.rows[i].Col14,
                    _unitCode: this.state.rows[i]._unitCode,
                    _refLineID: this.state.rows[i]._refLineID,
                    maingroup: this.state.rows[i].maingroup,
                    STOCKTYPE: this.state.rows[i].STOCKTYPE,
                    ITEMTAXTYPE: this.state.rows[i].ITEMTAXTYPE,
                    productset: this.state.rows[i].productset
                }
            }
        }
        if (reData.length === sb_length && reData.length !== 0) {
            this.props.Get_PopUpSelSaleRef3Sub(reData);
        }
    };
    onRowDoubleClick(data, col, id, row) {
        //  
        console.log("sssssssssssssssssssssssssssssssssssssss", col);

    }

    render() {

        const options = {
            onRowDoubleClick: this.onRowDoubleClick,
            onRowClick: this.onSelectRow,
            noDataText: "ไม่พบข้อมูลที่ค้นหา"
        };

        return (

            <div className='popup' style={{ 'z-index': '100' }} >
                <Backdrop open={this.state.openBackdrop} />
                <div className='popup_inner'>{/* popup_inner_arinvdebt divBox */}
                    {this.props.Data}
                    <div class="PopUpOtherDivH" align="left">
                        <div class="PopUpOtherDivH1">
                            <i class="fas fa-search">{this.state.Htext} </i>
                        </div>
                        <div class="PopUpOtherDivH2" onClick={this.props.closePopup}>
                            <i class="fas fa-times"></i>
                        </div>
                        {/* <div class="PopUpOtherDivH1"><i class="fas fa-at" > {this.state.Htext} </i></div>
                            <div class="PopUpOtherDivH2"><i class="fas fa-times" onClick={this.props.closePopup}></i></div> */}
                    </div>
                    <div class="panel-body divTable" align="left">
                        {/* <div class="col-md-2">
                                <img src={mainLogo} width="100%" />
                            </div>
                            <div class="col-md-10" align="left">
                                <div class="input-group group-custom" style={{ padding: "5px",marginTop:"40px" }}>
                                    {this.state.sh_Deposit === true ?
                                        <div class=" form-group input-group col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                                            <input id="id1" type="text" class="form-control" ref="Search" onKeyPress={this.Get_Data.bind(null)} onBlur={this.Get_Data.bind(null, "ARInvDebt")} />
                                            <span id="iconsearch" class="input-group-addon icon"><i class="fas fa-search"></i></span>
                                        </div>
                                        : null}
                                </div>
                            </div> */}
                        <div class="input-group width-grop">
                            <input type="text" class="form-control" placeholder="ค้นหาเลขที่เอกสาร" onKeyUp={this.onKeyUp} ref="Code" />
                            <span class="input-group-addon txt-img icon">
                                <i class="fas fa-search" onClick={this.Get_Data}></i>
                            </span>
                            <span class="input-group-addon txt-img icon">
                                <i class="fas fa-sync-alt" onClick={this.Get_Data.bind(null, "true")}></i>
                            </span>
                        </div>
                        <div style={{ marginTop: "10px" }}>

                            <BootstrapTable
                                data={this.state.rows}
                                options={options}
                                height="500"

                                hover condensed /* search */>
                                <TableHeaderColumn columnClassName="columnAll columnNumber" className="columnNumber" dataAlign="center" width="35" dataField='number' isKey /* dataFormat={this._chkload.bind(this)} */ ><div onClick={this.props.closePopup}><i class="fas fa-reply-all" ></i> </div></TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="35" dataField='SB' editable={false} dataAlign="center" dataFormat={this.cellcheckbok.bind(this)} > <div onClick={this.Update_Status.bind(null, "", "ALL")} > <i class={this.state.casschkbox}> </i> </div> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="120" dataField='Col1'> เลขที่เอกสาร </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="120" dataField='Col2' > รหัสสินค้า </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > ชื่อสินค้า </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col4' dataAlign="left" > หน่วย </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col5' dataAlign="left"> ปริมาณ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col6' dataAlign="left"> ค้าง </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col7' dataAlign="left"> จัดได้ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col8' dataAlign="right"> ราคา/หน่วย </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col9' dataAlign="right"> ลด </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col10' dataAlign="right"> พนักงานขาย </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col11' dataAlign="right"> หมายเหตุพนักงาน </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col12' dataAlign="right"> หมายเหตุการจัดสินค้า </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataAlign="right" dataField='_unitCode' >_unitCode</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataAlign="right" dataField='_refLineID' >_refLineID</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataAlign="right" dataField='maingroup' >Maingroup</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataAlign="right" dataField='STOCKTYPE' >STOCKTYPE</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataAlign="right" dataField='ITEMTAXTYPE' >ITEMTAXTYPE</TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataAlign="right" dataField='productset' >productset</TableHeaderColumn>

                                <TableHeaderColumn dataField='Col13' hidden></TableHeaderColumn>
                                <TableHeaderColumn dataField='Col14' hidden></TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                        <div style={{ float: 'right' }}>
                            {this.state.TableHidden ? ("") : (
                                <button class="PUSDbtn" onClick={this.props.closePopup} >
                                    <i class="fas fa-reply-all"> กลับ </i>
                                </button>
                            )}
                            <button class="PUSDbtn" onClick={this.onSubmit}>
                                <i class="fas fa-check"> ตกลง </i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}